export default __webpack_public_path__ + "static/media/overview-icon.6d29c542.png";